export enum AclRoleAccess {
  None = 0,
  Read = 5,
  Write = 10,
  Full = 15,
}
